import { createSlice } from "@reduxjs/toolkit";

export interface INiveauAccesState {
  objNiveauAcces: IObjNiveauAcces;
  currentObjetNiveauAcces: INiveauAcces;
  niveauAcces: any;
  filteredNiveauAcces:any;
}

export interface IObjNiveauAcces {
  libelleNiveauAcces: string;
  descriptionNiveauAcces: string;
  niveauVerification: string;
  idNiveauVerification: string;
}
export interface INiveauAcces {
  description: string;
  idNiveauAccesGlobal: string;
  idNiveauVerification: string;
  libelle: string;
  niveauVerification: string;
  statut: number;
}
// export interface INiveauAcces {
//   description: "desc"
//   idNiveauAccesGlobal: "NAGS001"
//   idNiveauVerification: "MOD005"
//   libelle: "Administrateur"
//   niveauVerification: "module"
//   statut: 0
// }
// export interface INiveauAcces {
//   idNiveauAcces: number;
//   idNiveauVerification?: string;
//   libelleNiveauAcces: string;
//   descriptionNiveauAcces: string;
//   niveauVerification?: string;
//   valeurNiveauVerification: string;
// }

export const initialObjNiveauAcces = {
  libelle: "",
  description: "",
  niveauVerification: "",
  idNiveauVerification: ""
}

export const niveauAccesSlice: any = createSlice({
  name: "niveauAcces",
  initialState: {
    currentObjetNiveauAcces: {},
    niveauAcces: [],
    filteredNiveauAcces: []
  },
  reducers: {

    setCurrentObjetNiveauAcces: (state, action) => {
      state.currentObjetNiveauAcces = action.payload;
    },

    addiNveauAcces: (state, action) => {
      const newNA: any = [...state.niveauAcces, action.payload]
      state.niveauAcces = newNA;
    },

    setNveauAcces: (state, action) => {
      state.niveauAcces = action.payload;
    },
    setFilteredNveauAcces: (state, action) => {
      state.filteredNiveauAcces = action.payload;
    },

  }
});

export const { setCurrentObjetNiveauAcces, addiNveauAcces,setNveauAcces,setFilteredNveauAcces } = niveauAccesSlice.actions;


export default niveauAccesSlice.reducer;
